<div class="history-jobs-container">
  <evrideo-transcoding-job-report
    *ngIf="vm.selectedJob"
    [vm]="vm"
    [loadingMessage]="reportLoadingMessage"
  ></evrideo-transcoding-job-report>
  <div class="filters-bar flex row">
    <div class="filter-group">
      <span class="filter-label">Name</span>
      <input
        class="name-filter-input"
        type="search"
        placeholder="Search by name"
        [ngModel]="vm.nameFilter"
        (ngModelChange)="vm.setNameFilter($event)"
      />
    </div>
    <div class="filter-group">
      <span class="filter-label">Item Status</span>
      <icn-dropdown
        class="filter-dropdown"
        [position]="'bottom'"
        [placeholder]="'All'"
        [selectedValue]="vm.selectedItemStatusFilter"
        (selectedValueChange)="vm.setItemStatusFilter($event)"
      >
        <icn-dropdown-item
          *ngFor="let option of vm.statusFilterOptions"
          [title]="option.label"
          [value]="option.value"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="filter-group bulk-action">
      <evrideo-hover-button (click)="openBulkRedoDialog()">
        <span>Bulk reschedule failed</span>
      </evrideo-hover-button>
    </div>
  </div>
  <table class="jobs-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Destination</th>
        <th>Start Time(UTC)</th>
        <th>End Time(UTC)</th>
        <th>Duration</th>
        <th>Item Status</th>
        <th>Redo</th>
        <th>Report</th>
        <th>Replicate</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let job of vm.jobs">
        <td>{{ job.name }}</td>
        <td>{{ job.destination }}</td>
        <td>{{ job.actualStartTime }}</td>
        <td>{{ job.actualEndTime }}</td>
        <td>{{ job.duration }}</td>
        <td class="status-cell">{{ job.itemStatusDisplay }}</td>
        <td class="redo-cell">
          <a
            *ngIf="job.hasRedoLink"
            [routerLink]="'../edit/' + job.redoJobId"
            [title]="job.redoJobName"
            >{{ job.redoStatusLabel }}</a
          >
          <span *ngIf="!job.hasRedoLink">—</span>
        </td>
        <td class="actions-cell"><span (click)="vm.showReport(job)">Report</span></td>
        <td class="actions-cell">
          <a [routerLink]="'../new/replicateFromId/' + job.id">
            <span>Replicate</span></a
          >
        </td>
      </tr>
    </tbody>
  </table>

  <ngx-smart-modal
    identifier="historyBulkRedoModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered history-bulk-redo-modal'"
    [closable]="false"
    [escapable]="true"
    [dismissable]="true"
  >
    <evrideo-history-bulk-redo-dialog
      (completed)="onBulkRedoCompleted()"
    ></evrideo-history-bulk-redo-dialog>
  </ngx-smart-modal>
</div>
